import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearCompanyTypes, fecthAllCompanyTypes } from '../../../../store/slices/company';

export const useFetchCompanyTypes = () => {
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();
  const companyTypes = useSelector(state => state.company.companyTypes);

  const fetchCompanyTypes = useCallback(() => {
    try {
      setLoading(true);
      if (companyTypes.length === 0) {
        dispatch(fecthAllCompanyTypes());
      }
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    fetchCompanyTypes();
    return () => dispatch(clearCompanyTypes());
  }, [dispatch, fetchCompanyTypes]);

  return {
    loading,
    companyTypes,
  };
};